import { ProcessEventSchema } from '../../entities/process-draft/process-event.schema';
/**
 * PATCH /api/v2/process/:id/draft/events/:eventId — update the entity. The
 * server patches the denormalized snapshot on every step input that
 * references this `eventId` in a single pass.
 *
 * The response envelope carries the updated event ROW plus the full docs of
 * every node whose denormalized input snapshot was patched.
 */ export const UpdateDraftEventRequestSchema = ProcessEventSchema.pick({
    eventType: true,
    name: true,
    description: true
}).partial();

//# sourceMappingURL=update-draft-event.schema.js.map